// 资源名称相关常量
export const RESOURCE_NAME_MAX_LENGTH = 20;

// 资源树中名称显示截断长度
export const RESOURCE_TITLE_DISPLAY_MAX_LENGTH = 16;
